export default (phoneNumber: string) => {
  const strippedPhoneNumber = phoneNumber.trim().replace(/\D/g, '');
  if (/^[0-9]{10}$/.test(strippedPhoneNumber)) return undefined;
  return 'Invalid phone number (555) 555-5555';
};
